import React from "react";
import { DatoTotal, PanelTotales } from "./PanelTotales";

export const TancadasResumen = (props) => {
    const { totales = {} } = props;
    const kgHum = totales.kg_humedos || {};
    const porcentajes = totales.porcentajes || {};

    return (
        <PanelTotales>
            <DatoTotal
                etiqueta="Chipa de primera, segunda, cóagulo:"
                kg={kgHum.normal}
                porcentaje={porcentajes.normal || 0}
                anchoMaximoEtiqueta="150px"
            />
            <DatoTotal
                etiqueta="Reproceso:"
                kg={kgHum.reproceso}
                porcentaje={porcentajes.reproceso || 0}
            />
            <DatoTotal
                etiqueta="Skim:"
                kg={kgHum.skim}
                porcentaje={porcentajes.skim || 0}
            />
        </PanelTotales>
    );
};
